import { BillingChargesListingPage } from 'components/lab/billingCharge/BillingChargesListingPage'
import { BillingChargeUpsert } from 'components/lab/billingCharge/BillingChargeUpsert'
import { BillingEraReportsListingPage } from 'components/lab/billingEraReports/BillingEraReportsListingPage'
import { EraExceptionQueuePage } from 'components/lab/billingEraReports/EraExceptionQueuePage'
import { DenialsWorklistPage } from 'components/lab/billingDenial/DenialsWorklistPage'
import { NeedsWorkListPage } from 'components/lab/billingNeedsWork/NeedsWorkListPage'
import { PaperStatementsPage } from 'components/lab/billingPatientStatements/PaperStatementsPage'
import { PendingStatementsPage } from 'components/lab/billingPatientStatements/PendingStatementsPage'
import Menu from './menu/Menu'
import Index from './index/Index'
import Footer from './footer/Footer'
import { useState, useEffect } from 'react'
import { useAppSelector } from 'hooks/redux'

import Companies from './company/Companies'
import CompanyUpsert from './company/CompanyUpsert'
import OfficeUpsert from './office/OfficeUpsert'
import Fax from './fax/Fax'
import Order from './order/Order'
import OrderEdit from './orderEdit/OrderEdit'
import OrderNightOwlEdit from './orderEdit/NightOwlEdit'
import SendFax from './fax/SendFax'
import IncomingDocuments from './fax/IncomingDocuments'
import OutgoingDocuments from './fax/OutgoingDocuments'
import Device from './device/Device'
import Physician from './physician/Physician'
import PhysicianDetails from './physician/PhysicianDetails'
import DeviceUpsert from './device/DeviceUpsert'
import AccessoriesDue from './device/AccessoriesDue'
import File from './file/File'
import FileUpsert from './file/FileUpsert'
import FileType from './fileType/FileType'
import FileTypeUpsert from './fileType/FileTypeUpsert'
import DeviceType from './deviceType/DeviceType'
import DeviceTypeUpsert from './deviceType/DeviceTypeUpsert'
import DeviceCategory from './deviceCategory/DeviceCategory'
import DeviceCategoryUpsert from './deviceCategory/DeviceCategoryUpsert'
import DeviceTypeLink from './deviceTypeLink/DeviceTypeLink'
import DeviceTypeLinkUpsert from './deviceTypeLink/DeviceTypeLinkUpsert'
import PhysicianGroupsDirectory from './physicianGroups/PhysicianGroupsDirectory'
import PhysicianGroupUpsert from './physicianGroups/PhysicianGroupUpsert'
import CatalogDirectory from './catalog/CatalogDirectory'
import CatalogItemUpsert from './catalog/CatalogItemUpsert'
import PhysicianGroupUsersDirectory from './physicianGroups/PhysicianGroupUsersDirectory'
import PhysicianGroupUserUpsert from './physicianGroups/PhysicianGroupUserUpsert'
import Status from './status/Status'
import StatusUpsert from './status/StatusUpsert'
import Payer from './payer/Payer'
import DmePayer from './payer/DmePayer'
import PayerChargeRules from './payerChargeRules/PayerChargeRules'
import OrderDiagnostic from './orderDiagnostic'
import Directory from './patient/Directory'
import PatientDetails from './patient/PatientDetails'
import NewExistingPatientOrder from 'components/dme/order/NewExistingPatientOrder'
import LabUsersList from 'components/lab/user/Directory'
import LabUserUpsert from 'components/lab/user/UserUpsert'
import DmeUserDirectory from './office/UserDirectory'
import DmeUserUpsert from './office/UserUpsert'
import Stats from './managementReports/Stats'
import Analytics from './managementReports/Analytics'
import BillingAnalytics from './managementReports/BillingAnalytics'
import PatientAgingReport from './managementReports/PatientAgingReport'
import FollowUpCareReports from './managementReports/FollowUpCareReports'
import PreferenceSetupReport from './managementReports/PreferenceSetupReport'
import AuditTrail from './managementReports/AuditTrail'
import BankDepositReport from './managementReports/BankDepositReport'
import WriteOffReport from './managementReports/WriteOffReport'
import ProductivityReport from './managementReports/ProductivityReport'
import BulletinDirectory from './bulletins/BulletinDirectory'
import BulletinUpsert from './bulletins/BulletinUpsert'
import TagDirectory from './tags/TagDirectory'
import BillingSettings from './billingSettings/BillingSettings'
import PlatformSettings from './platformSettings/PlatformSettings'
import RetellOutboundSettings from './retellOutboundSettings/RetellOutboundSettings'
import RetellOutboundActivity from './retellOutboundActivity/RetellOutboundActivity'
import ReaderAppSettings from './readerApp/ReaderAppSettings'

import NewPatient from 'components/lab/patient/NewPatient'
import NewOrder from 'components/lab/patient/NewPatientOrder'

import routes from './constants/routes'
import '../dme/css/adminlte.min.css'
import './css/extend.css'
import './css/extend.scss'
import './css/mobile-responsive.scss'
import { Navigate, Routes, Route, useLocation } from 'react-router-dom'
import DeviceImport from './deviceImport/DeviceImportTable'
import BillingProcedures from './billingProcedures/BillingProcedures'
import NewBillingProcedure from './billingProcedures/NewBillingProcedure'
import EditBillingProcedure from './billingProcedures/EditBillingProcedure'
import V1ArchivePage from './v1Archive/V1ArchivePage'
import { initializeLabSavedBuckets } from './state/savedBucketsStore'
import { initializeSoundAlertBuckets } from './state/soundAlertBucketsStore'
import { useSoundNotifications } from 'hooks/useSoundNotifications'

const DashboardLab = () => {
  const location = useLocation()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const initialSavedBuckets = useAppSelector((state) => state.init.savedBuckets ?? [])
  const initialNotificationBuckets = useAppSelector((state) => state.init.notificationBuckets ?? [])

  useSoundNotifications()

  useEffect(() => {
    // Add AdminLTE layout classes to body
    document.body.classList.add('layout-fixed')
    document.body.classList.add('sidebar-mini')

    return () => {
      // Clean up classes when component unmounts
      document.body.classList.remove('layout-fixed')
      document.body.classList.remove('sidebar-mini')
    }
  }, [])

  useEffect(() => {
    initializeLabSavedBuckets(initialSavedBuckets)
  }, [initialSavedBuckets])

  useEffect(() => {
    initializeSoundAlertBuckets(initialNotificationBuckets)
  }, [initialNotificationBuckets])

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false)
  }

  // Upsert links carried a double slash (/lab/device//upsert/12) until TES-3191; saved ones still open.
  // Route paths are matched as written, so none of them may hold a double slash (routes.test.ts).
  if (location.pathname.includes('//')) {
    return <Navigate replace to={{ ...location, pathname: location.pathname.replace(/\/{2,}/g, '/') }} />
  }

  return (
    <div className="wrapper">
      {/* Mobile Menu Toggle Button */}
      <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
        ☰
      </button>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && <div className="mobile-menu-overlay" onClick={closeMobileMenu} />}

      {/* Menu with mobile class */}
      <Menu isMobileMenuOpen={isMobileMenuOpen} closeMobileMenu={closeMobileMenu} />

      <div className="content-wrapper">
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path={`${routes.company.root}`} element={<Companies />} />
          <Route path={`${routes.company.root}${routes.upsert}`} element={<CompanyUpsert />} />
          <Route
            path={`${routes.company.root}${routes.upsert}:companyId`}
            element={<CompanyUpsert />}
          />
          <Route path={`${routes.office.root}${routes.upsert}`} element={<OfficeUpsert />} />
          <Route
            path={`${routes.office.root}${routes.upsert}:officeId`}
            element={<OfficeUpsert />}
          />
          <Route path={`${routes.fax.root}`} element={<Fax />} />
          <Route path={`${routes.fax.root}${routes.fax.incoming}`} element={<IncomingDocuments />} />
          <Route path={`${routes.fax.root}${routes.fax.outgoing}`} element={<OutgoingDocuments />} />
          <Route path={`${routes.fax.root}${routes.fax.send}`} element={<SendFax />} />
          <Route path={`${routes.deviceType.root}`} element={<DeviceType />} />
          <Route
            path={`${routes.deviceType.root}${routes.upsert}`}
            element={<DeviceTypeUpsert />}
          />
          <Route
            path={`${routes.deviceType.root}${routes.upsert}:id`}
            element={<DeviceTypeUpsert />}
          />
          <Route path={`${routes.deviceCategory.root}`} element={<DeviceCategory />} />
          <Route
            path={`${routes.deviceCategory.root}${routes.upsert}`}
            element={<DeviceCategoryUpsert />}
          />
          <Route
            path={`${routes.deviceCategory.root}${routes.upsert}:id`}
            element={<DeviceCategoryUpsert />}
          />
          <Route path={`${routes.deviceTypeLink.root}`} element={<DeviceTypeLink />} />
          <Route
            path={`${routes.deviceTypeLink.root}${routes.upsert}`}
            element={<DeviceTypeLinkUpsert />}
          />
          <Route
            path={`${routes.deviceTypeLink.root}${routes.upsert}:id`}
            element={<DeviceTypeLinkUpsert />}
          />
          <Route path={`${routes.device.root}`} element={<Device />} />
          <Route path={`${routes.accessoryReplacement.root}`} element={<AccessoriesDue />} />
          <Route path={`${routes.device.root}${routes.upsert}`} element={<DeviceUpsert />} />
          <Route path={`${routes.device.root}${routes.upsert}:id`} element={<DeviceUpsert />} />
          <Route path={`${routes.status.root}`} element={<Status />} />
          <Route path={`${routes.status.root}${routes.upsert}`} element={<StatusUpsert />} />
          <Route path={`${routes.status.root}${routes.upsert}:id`} element={<StatusUpsert />} />
          <Route path={`${routes.deviceImport.root}`} element={<DeviceImport />} />
          <Route path={`${routes.payer.root}`} element={<Payer />} />
          <Route path={`${routes.dmePayer.root}`} element={<DmePayer />} />
          <Route path={`${routes.payerChargeRules.root}`} element={<PayerChargeRules />} />
          <Route path={`${routes.file.root}`} element={<File />} />
          <Route path={`${routes.file.root}${routes.upsert}`} element={<FileUpsert />} />
          <Route path={`${routes.file.root}${routes.upsert}:id`} element={<FileUpsert />} />
          <Route path={`${routes.fileType.root}`} element={<FileType />} />
          <Route path={`${routes.fileType.root}${routes.upsert}`} element={<FileTypeUpsert />} />
          <Route path={`${routes.fileType.root}${routes.upsert}:id`} element={<FileTypeUpsert />} />
          <Route path={`${routes.order.root}`} element={<Order />} />
          <Route path={`${routes.order.edit}:orderId`} element={<OrderEdit />} />
          <Route
            path={`${routes.billing.root}${routes.billing.charge}`}
            element={<BillingChargesListingPage />}
          />
          <Route
            path={`${routes.billing.root}${routes.billing.paperClaims}`}
            element={<BillingChargesListingPage paperClaims />}
          />
          <Route
            path={`${routes.billing.root}${routes.billing.eraFiles}`}
            element={<BillingEraReportsListingPage />}
          />
          <Route
            path={`${routes.billing.root}${routes.billing.eraExceptions}`}
            element={<EraExceptionQueuePage />}
          />
          <Route
            path={`${routes.billing.root}${routes.billing.needsWork}`}
            element={<NeedsWorkListPage />}
          />
          <Route
            path={`${routes.billing.root}${routes.billing.denials}`}
            element={<DenialsWorklistPage />}
          />
          <Route
            path={`${routes.billing.root}${routes.billing.pendingStatements}`}
            element={<PendingStatementsPage />}
          />
          <Route
            path={`${routes.billing.root}${routes.billing.paperStatements}`}
            element={<PaperStatementsPage />}
          />
          <Route
            path={`${routes.billing.root}${routes.billing.analytics}`}
            element={<BillingAnalytics />}
          />
          <Route
            path={`${routes.billing.root}${routes.billing.kpiScorecard}`}
            element={<BillingAnalytics dashboardId="billing-kpi-scorecard" />}
          />
          <Route
            path={`${routes.billing.root}${routes.billing.reports}`}
            element={<BillingAnalytics dashboardId="billing-reports" />}
          />
          <Route
            path={`${routes.order.edit}${routes.order.nightOwl}:orderId`}
            element={<OrderNightOwlEdit />}
          />
          <Route
            path={`${routes.patient.root}${routes.patient.directory}`}
            element={<Directory />}
          />
          <Route path={`${routes.patient.root}/:patientId`} element={<PatientDetails />} />
          <Route
            path={`${routes.patient.root}/:patientId${routes.billing.root}${routes.billing.charge}${routes.billing.new}`}
            element={<BillingChargeUpsert />}
          />
          <Route
            path={`${routes.patient.root}/:patientId${routes.billing.root}${routes.billing.charge}${routes.billing.edit}:chargeId`}
            element={<BillingChargeUpsert />}
          />
          <Route
            path={`${routes.patient.root}${routes.patient.moveReport}`}
            element={<Directory />}
          />
          <Route
            path={`${routes.patient.root}${routes.patient.editReportConditions}`}
            element={<Directory />}
          />
          <Route
            path={`${routes.patient.root}${routes.patient.mergePatients}`}
            element={<Directory />}
          />
          <Route path={`${routes.order.root}${routes.order.new}`} element={<NewPatient />} />
          <Route
            path={`${routes.order.root}${routes.order.new}orderDetails`}
            element={<NewOrder />}
          />
          <Route
            path={`${routes.order.root}${routes.order.new}patient/:patientId/orderDetails`}
            element={<NewExistingPatientOrder context="LAB" />}
          />
          <Route path={`${routes.order.diagnostic}`} element={<OrderDiagnostic />} />
          <Route path={`${routes.order.diagnostic}:orderId`} element={<OrderDiagnostic />} />
          <Route
            path={`${routes.labUsers.root}${routes.labUsers.directory}`}
            element={<LabUsersList />}
          />
          <Route
            path={`${routes.physicianGroupUsers.root}${routes.physicianGroupUsers.directory}`}
            element={<PhysicianGroupUsersDirectory />}
          />
          <Route
            path={`${routes.physicianGroupUsers.root}${routes.upsert}:userId`}
            element={<PhysicianGroupUserUpsert />}
          />
          <Route
            path={`${routes.physicianGroupUsers.root}${routes.upsert}`}
            element={<PhysicianGroupUserUpsert />}
          />
          <Route path={`${routes.physicianGroups.root}`} element={<PhysicianGroupsDirectory />} />
          <Route
            path={`${routes.physicianGroups.root}${routes.upsert}`}
            element={<PhysicianGroupUpsert />}
          />
          <Route
            path={`${routes.physicianGroups.root}${routes.upsert}:physicianGroupId`}
            element={<PhysicianGroupUpsert />}
          />
          <Route path={`${routes.labUsers.root}${routes.upsert}`} element={<LabUserUpsert />} />
          <Route
            path={`${routes.labUsers.root}${routes.upsert}:userId`}
            element={<LabUserUpsert />}
          />
          <Route
            path={`${routes.dmeUsers.root}${routes.dmeUsers.directory}`}
            element={<DmeUserDirectory />}
          />
          <Route path={`${routes.dmeUsers.root}${routes.upsert}`} element={<DmeUserUpsert />} />
          <Route
            path={`${routes.dmeUsers.root}${routes.upsert}:userId`}
            element={<DmeUserUpsert />}
          />
          <Route path={`${routes.reports.root}${routes.reports.stats}`} element={<Stats />} />
          <Route
            path={`${routes.reports.root}${routes.reports.patientAging}`}
            element={<PatientAgingReport />}
          />
          <Route
            path={`${routes.reports.root}${routes.reports.followUpCare}`}
            element={<FollowUpCareReports />}
          />
          <Route
            path={`${routes.reports.root}${routes.reports.preferenceSetup}`}
            element={<PreferenceSetupReport />}
          />
          <Route
            path={`${routes.reports.root}${routes.reports.analytics}`}
            element={<Analytics />}
          />
          <Route
            path={`${routes.reports.root}${routes.reports.bankDeposit}`}
            element={<BankDepositReport />}
          />
          <Route
            path={`${routes.reports.root}${routes.reports.writeOffs}`}
            element={<WriteOffReport />}
          />
          <Route
            path={`${routes.reports.root}${routes.reports.auditTrail}`}
            element={<AuditTrail />}
          />
          <Route
            path={`${routes.reports.root}${routes.reports.productivity}`}
            element={<ProductivityReport />}
          />
          <Route
            path={`${routes.bulletins.root}${routes.bulletins.directory}`}
            element={<BulletinDirectory />}
          />
          <Route
            path={`${routes.tags.root}${routes.tags.directory}`}
            element={<TagDirectory />}
          />
          <Route
            path={`${routes.retellOutboundSettings.root}`}
            element={<RetellOutboundSettings />}
          />
          <Route
            path={`${routes.billingSettings.root}`}
            element={<BillingSettings />}
          />
          <Route
            path={`${routes.platformSettings.root}`}
            element={<PlatformSettings />}
          />
          <Route
            path={`${routes.retellOutboundActivity.root}`}
            element={<RetellOutboundActivity />}
          />
          <Route
            path={`${routes.readerAppSettings.root}`}
            element={<ReaderAppSettings />}
          />
          <Route path={`${routes.bulletins.root}${routes.upsert}`} element={<BulletinUpsert />} />
          <Route
            path={`${routes.bulletins.root}${routes.upsert}:bulletinId`}
            element={<BulletinUpsert />}
          />
          <Route path={`${routes.physician.root}`} element={<Physician />} />
          <Route
            path={`${routes.physician.root}${routes.physician.upsert}:npi`}
            element={<PhysicianDetails />}
          />
          <Route path={`${routes.catalog.root}`} element={<CatalogDirectory />} />
          <Route
            path={`${routes.catalog.root}${routes.upsert}`}
            element={<CatalogItemUpsert />}
          />
          <Route
            path={`${routes.catalog.root}${routes.upsert}:id`}
            element={<CatalogItemUpsert />}
          />
          <Route
            path={`${routes.billing.root}${routes.billing.procedures}`}
            element={<BillingProcedures />}
          />
          <Route
            path={`${routes.billing.root}${routes.billing.procedures}${routes.billing.edit}:procedureId`}
            element={<EditBillingProcedure />}
          />
          <Route
            path={`${routes.billing.root}${routes.billing.procedures}${routes.billing.new}`}
            element={<NewBillingProcedure />}
          />
          <Route path={routes.v1Archive.root} element={<V1ArchivePage />} />
        </Routes>
      </div>
      <Footer />
    </div>
  )
}

export default DashboardLab
